function resultTypeShowDirective() {
	return {
		scope : {
			techniqueInfo : '=',
			characterOpen : '@?',
			characterClose : '@?'
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/resultTypeShowDirective.html';
		},
		controller : [ '$scope', function($scope) {
			$scope.charOpen = '';
			$scope.charClose = '';
			if (!angular.isUndefined($scope.characterOpen))
				$scope.charOpen = $scope.characterOpen;
			if (!angular.isUndefined($scope.characterClose))
				$scope.charClose = $scope.characterClose;
		} ]
	};
};

module.directive('resultTypeShow', [ resultTypeShowDirective ]);